document.addEventListener('DOMContentLoaded', function() {
  var inchBtn = document.getElementById('inchBtn');
  var cmBtn = document.getElementById('cmBtn');
  var inchTable = document.getElementById('inchTable');
  var cmTable = document.getElementById('cmTable');

  if (!inchBtn || !cmBtn) return;

  inchBtn.addEventListener('click', function(e) {
    e.preventDefault();
    inchTable.style.display = 'table';  // ← 改这里
    cmTable.style.display = 'none';
    inchBtn.classList.add('active');
    cmBtn.classList.remove('active');
  });

  cmBtn.addEventListener('click', function(e) {
    e.preventDefault();
    cmTable.style.display = 'table';    // ← 改这里
    inchTable.style.display = 'none';
    cmBtn.classList.add('active');
    inchBtn.classList.remove('active');
  });
});
